'use strict';
var $ = require('jquery');

/**
 * @function
 * @description Initialise the one width product hint
 */
exports.init = function () {
    var widthMessageOpen = 'width-message-open';

    $('body').on('click', '.product-hint-width', function (e) {
        e.stopPropagation();
        triggerClassWidth();
    });

    $('body').on('click', '.product-hint-width-message .close-button', hideWidthMessage);

    function triggerClassWidth() {
        var $productHintWidth = $('.product-hint-width-message');
        if (!$productHintWidth.hasClass(widthMessageOpen)) {
            showWidthMessage();
            if (!$productHintWidth.isFullyVisible()) {
                scrollToMiddle();
            }
        } else if ($productHintWidth.hasClass(widthMessageOpen)) {
            hideWidthMessage();
        }
    }

    function scrollToMiddle() {
        $('html, body').animate(
            {
                scrollTop:
                    $('.product-hint-width-message').offset().top -
                    ($(window).height() - $('.product-hint-width-message').outerHeight(true)) / 2
            },
            1000
        );
    }

    function showWidthMessage() {
        $('.product-hint-width-message').addClass(widthMessageOpen);
    }

    function hideWidthMessage() {
        $('.product-hint-width-message').removeClass(widthMessageOpen);
    }

    $(document).on('click', function (e) {
        if (
            !$('.product-hint-width-message').is(e.target) &&
            $('.product-hint-width-message').has(e.target).length === 0
        ) {
            hideWidthMessage();
        }
    });

    $.fn.isFullyVisible = function () {
        var win = $(window);

        var viewport = {
            top: win.scrollTop(),
            left: win.scrollLeft()
        };

        viewport.right = viewport.left + win.width();
        viewport.bottom = viewport.top + win.height();

        var elemtHeight = this.height(); // Get the full height of current element
        elemtHeight = Math.round(elemtHeight); // Round it to a whole number

        var bounds = this.offset(); // Coordinates of current element
        bounds.top = bounds.top + elemtHeight;
        bounds.right = bounds.left + this.outerWidth();
        bounds.bottom = bounds.top + this.outerHeight();

        return !(
            viewport.right < bounds.left ||
            viewport.left > bounds.right ||
            viewport.bottom < bounds.top ||
            viewport.top > bounds.bottom
        );
    };
};
